import { checkStatusCode } from "./utils";

export async function generalSearchAsync(body) {
    const req = await fetch(process.env.REACT_APP_API_URL + '/api/search', {
        method: "POST",
        credentials: "include",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
    });
    checkStatusCode(req);
    const res = await req.json();
    if (res.error) throw res;
    return res;
}
